import { render, staticRenderFns } from "./MergeContext.vue?vue&type=template&id=98df0d70"
import script from "./MergeContext.vue?vue&type=script&lang=js"
export * from "./MergeContext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports